import { Injectable } from '@angular/core';
import { ToastButton, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { ErrorMessage } from '../../newapp/shared/helpers/formUtils.helper';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private static TOASTS_KEY = 'errors.';

  constructor(private toast: ToastController, private translate: TranslateService) {}

  async showToastForm(errorMessage : ErrorMessage): Promise<void> {
    const toast = await this.toast.create({
      message: (errorMessage.extractedErrorsFromApiText) ? (`${errorMessage.message}<br /><small>${errorMessage.extractedErrorsFromApiText}</small>`) : errorMessage.message,
      duration: 5000,
      position: 'top',
      animated: true,
      mode: 'ios',
      color: (errorMessage.isError) ? 'danger' : 'warning',
      buttons: []
    });

    await toast.present();
  }

  async showToast(message: string, color: 'success' | 'danger' | 'warning', duration? : number | null, buttons? : ToastButton[]): Promise<void> {
    const toast = await this.toast.create({
      message,
      duration: (duration) || 5000,
      position: 'top',
      animated: true,
      mode: 'ios',
      color,
      buttons: (buttons) || []
    });

    await toast.present();
  }

  async toastError(msg: string, duration = 2000, buttons: ToastButton[] = []): Promise<void> {
    Sentry.captureMessage(msg, 'error');
    return this.showToast(this.translate.instant(ToastService.TOASTS_KEY + msg), 'danger', duration, buttons);
  }

  async toastSuccess(msg: string, duration?: number): Promise<void> {
    return this.showToast(this.translate.instant(msg), 'success', duration);
  }

  async warning(msg: string): Promise<void> {
    return this.showToast(this.translate.instant(ToastService.TOASTS_KEY + msg), 'warning');
  }
}
